// extracted by mini-css-extract-plugin
export default {"tooltip":"oo-z","sharingV2":"po-z","sharingIconsV2":"qo-z","links":"ro-z","link":"so-z","facebookV2":"to-z","twitterV2":"uo-z","pinterestV2":"vo-z"};